import { Component, OnInit, Input } from '@angular/core';
import { TooltipPosition, DateTooltipPlace } from 'src/app/common/enums/enums';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements OnInit {

  @Input() fieldEnabled: boolean;
  @Input() showWarning: boolean;
  @Input() inputValue: string;
  @Input() tooltipPosition: TooltipPosition;
  @Input() popupWidth : string;
  @Input() dateTooltipPlace: DateTooltipPlace;
  @Input() isExpand?: boolean;
  isVisible: boolean = false;
  tooltipContent: string = "";
  panelWidth: number;
  marignWidth : number = 50;
  popupStyle: string;
  constructor() { }

  ngOnInit(): void {
    console.log("fieldEnabled OnInit");
    //this.panelWidth = Number(this.popupWidth.replace('%',''));
    //this.setPopupStyle(this.panelWidth);
   }

  setPopupStyle(panelWidth: number){
    this.popupStyle = (panelWidth > this.marignWidth) ? "main": "short";
  }

  showHideTooltip()
  {
    // this.tooltipContent = 'The date '+'"'+this.inputValue +'"'+' unrecognized, can not be used for calculating ages. Dates can be entered in various forms, and can include '+"'"+'date modifiers'+"'"+ ' such as '+"'"+'cs'+"'"+ ' (circa), ' +"'"+'abt'+"'"+' (about), '+"'"+' bef'+"'"+' (before) etc. Please check the help file for more information. Double check your entry and correct if, or you can just leave it the way its. If you leave it alone, quatation mark will be shown around the date to show that it is unrecognized, but it will not cause any other problems.';

    this.tooltipContent = 'Dates can be entered in various forms, and can include '+"'"+'date modifiers'+"'"+ ' such as '+"'"+'cs'+"'"+ ' (circa), ' +"'"+'abt'+"'"+' (about), '+"'"+' bef'+"'"+' (before) etc. Please check the help file for more information. Double check your entry and correct if, or you can just leave it the way its. If you leave it alone, quatation mark will be shown around the date to show that it is unrecognized, but it will not cause any other problems.';

    this.isVisible = !this.isVisible;
  }

}
